var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group-title" }, [
    _c(
      "div",
      [
        _c("span", { staticClass: "group-title__content" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._t("default"),
      ],
      2
    ),
    _c("i", { staticClass: "yxt-icon-close", on: { click: _vm.onClose } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }